export const environment = {
    production: false,
    apiUrlBase: 'https://dev.api.commercial-analytics-lighthouse.xom.cloud',
    apiUrl: 'https://dev.api.commercial-analytics-lighthouse.xom.cloud',
};
